export default __webpack_public_path__ + "static/media/fund.485384be.svg";